const doc = [({"en":({"js":({"team_surveys":({"time_used":({"not_started":"Not started", "one_week_or_more":"One week+"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;